module.exports = __webpack_public_path__ + "static/img/15.4574ac0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/15.png
// module id = rZnk
// module chunks = 0